import React, { useState, useRef } from "react";
import SearchField from "./DataTableSearch";
import DataTable, { createTheme } from "react-data-table-component";
import { toSnake } from "./ReqResConvertCase";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { Button } from "reactstrap";
import TableSkeleton from "./Skeleton";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "react-bootstrap";
const CommonDataTable = (props) => {
  const { layoutModeType } = useSelector((state) => ({
    layoutModeType: state.Layout.layoutModeType,
  })
);
  createTheme("dark", {
    background: {
      default: "transparent",
    },
  });
  const [filterParams, setFilterParams] = useState({
    ...props.filterParams,
    currentPage: props.filterParams?.currentPage || 1,
    perPage: props.filterParams?.perPage || 20,
    search: props.filterParams?.search || ''
  });
  const searchTimeout = useRef(null);
  const updateFilterParams = async (newFilterParams) => {
    setFilterParams(newFilterParams);
    if (typeof props.fetchData === 'function') {
      await props.fetchData(newFilterParams);
    }
  };
  const handleSearch = (searchValue) => {
    // Clear any existing timeout
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }
    // Debounce: wait 300ms after user stops typing
    searchTimeout.current = setTimeout(() => {
      // Only search if 3+ chars, or if cleared (empty string)
      if (searchValue.length >= 3 || searchValue.length === 0) {
        const updatedFilterParams = {
          ...filterParams,
          search: searchValue,
          currentPage: 1 // Reset to first page when searching
        };
        updateFilterParams(updatedFilterParams);
      }
      // else: do nothing (don't fire API)
    }, 300);
  };
  const handleRowsPerPageChange = (newPerPage, page) => {
    const updatedFilterParams = {
      ...filterParams,
      currentPage: 1, // Reset to first page when changing rows per page
      perPage: newPerPage,
    };
    updateFilterParams(updatedFilterParams);
  };
  const handlePageChange = (page) => {
    const updatedFilterParams = {
      ...filterParams,
      currentPage: page,
    };
    updateFilterParams(updatedFilterParams);
  };
  const exportToExcel = async () => {
    let exportData;
    // If rows are selected, export only the selected rows; otherwise, export all data
    if (props.selectedRows && props.selectedRows.length > 0) {
      exportData = props.selectedRows;
    } else {
      exportData = props.data;
    }
    try {
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, `${props.exportFileName || "data"}.xlsx`, {
        bookType: "xlsx",
        type: "buffer",
        compression: true,
      });
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    }
  };
  return (
    <Row>
      <Col lg={12}>
        <Card style={{ marginTop: "15px", marginBottom: "60px" }}>
          <CardBody>
            <Row className="g-4">
              <div className="col-12">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div className="form-icon" style={{ flex: "1", maxWidth: "30%" }}>
                    {props.searchEnable && (
                      <div className="">
                        <SearchField
                          value={filterParams.search}
                          onSearch={handleSearch}
                          filterParams={filterParams}
                          fetchData={props.fetchData}
                        />
                      </div>
                    )}
                  </div>
                  <div>
                    {props.showAddButton && (
                      <Button
                        className="btn mb-3 btn-primary add-button-margin"
                        color="primary"
                        type="submit"
                        onClick={props.addOnClickMethod}
                      >
                        <i className="ri-add-line"></i>
                        {`${props.buttonName ? props.buttonName : "New"}`}
                      </Button>
                    )}
                    {props.showOrderButton && (
                      <Link
                        to="/order/order-product"
                        className="btn btn-primary add-button-margin"
                      >
                        Order Product
                      </Link>
                    )}
                    {props.showExportButton && (
                      <Button
                        className="btn btn-primary add-button-margin"
                        color="primary"
                        type="submit"
                        onClick={exportToExcel}
                      >
                        <i className="bx bxs-file-export"></i>Export
                      </Button>
                    )}
                    {props.showBulkImportButton && (
                      <Button
                        className="btn btn-primary add-button-margin"
                        color="primary"
                        type="submit"
                        onClick={props.bulkImport}
                      >
                        <i className="bx bxs-file-export"></i>BulkImport
                      </Button>
                    )}
                    {props.selectedRows.length === 0 ? null : (
                      <Button
                        className="btn btn-danger "
                        color="danger"
                        disabled={props.selectedRows.length === 0}
                        onClick={props.bulkDelete}
                      >
                        Delete Item
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </Row>
            <div className="table-responsive table-card  mb-1 datatable" style={{ marginTop: "-5.8px" }}>
              <DataTable
                theme={layoutModeType === "light" ? "" : "dark"}
                columns={props.columns}
                data={props.data}
                pagination
                highlightOnHover
                paginationServer
                selectableRows={props.checkboxEnabled ? props.checkboxEnabled : false}
                progressComponent={
                  <div style={{ width: "100%" }}>
                    <TableSkeleton rows={10} columns={props.columns.length} />
                  </div>
                }
                progressPending={props.loading}
                onChangeRowsPerPage={handleRowsPerPageChange}
                sortServer
                persistTableHead
                paginationPerPage={filterParams.perPage}
                paginationTotalRows={props.totalRows}
                paginationDefaultPage={filterParams.currentPage}
                onSelectedRowsChange={({ selectedRows }) => {
                  if (props.bulkSelected) {
                    props.bulkSelected(selectedRows);
                  }
                }}
                onChangePage={handlePageChange}
                onSort={(sortingColumns, order) => {
                  // Extract the orderBy column name
                  console.log(order);
                  let orderBy = sortingColumns.selector
                    .toString()
                    .replace("row => row.", "")
                    .replace("(row) => row.", "")
                    .replace("row%20=>%20row.", "");
                    console.log(orderBy);
                  const transformedOrderBy = toSnake(orderBy);
                  console.log(transformedOrderBy);
                  // Capitalize the order (e.g., 'asc' -> 'ASC')
                  const transformedOrder = order.toUpperCase();
                  // Create updated filter params
                  const updatedFilterParams = {
                    ...filterParams,
                    order: transformedOrder,
                    orderBy: transformedOrderBy,
                  };
                  // Update filter params and trigger the data fetch
                  setFilterParams(updatedFilterParams);
                  props.fetchData(updatedFilterParams);
                }}
              />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};
export default CommonDataTable;





















// import React, { useState, useRef } from "react";
// import SearchField from "./DataTableSearch";
// import DataTable, { createTheme } from "react-data-table-component";
// import { toSnake } from "./ReqResConvertCase";
// import { useSelector } from "react-redux";
// import * as XLSX from "xlsx";
// import { Button } from "reactstrap";
// import TableSkeleton from "./Skeleton";
// import { Link } from "react-router-dom";
// import { Card, CardBody, Col, Row } from "react-bootstrap";
// const CommonDataTable = (props) => {  

//   const { layoutModeType } = useSelector((state) => ({
//     layoutModeType: state.Layout.layoutModeType,
//   })
// );

//   createTheme("dark", {
//     background: {
//       default: "transparent",
//     },
//   });

//   const [filterParams, setFilterParams] = useState({
//     ...props.filterParams,
//     currentPage: props.filterParams?.currentPage || 1,
//     perPage: props.filterParams?.perPage || 20,
//     search: props.filterParams?.search || ''
//   });

//   const searchTimeout = useRef(null);

//   const updateFilterParams = async (newFilterParams) => {
//     setFilterParams(newFilterParams);
//     // if (typeof props.fetchData === 'function') {
//       await props.fetchData(newFilterParams);
//     // }
//   };

//   const handleSearch = (searchValue) => {
//     // Clear any existing timeout
//     if (searchTimeout.current) {
//       clearTimeout(searchTimeout.current);
//     }

//     // Debounce: wait 300ms after user stops typing
//     searchTimeout.current = setTimeout(() => {
//       // Only search if 3+ chars, or if cleared (empty string)
//       if (searchValue.length >= 3 || searchValue.length === 0) {
//         const updatedFilterParams = {
//           ...filterParams,
//           search: searchValue,
//           currentPage: 1 // Reset to first page when searching
//         };
//         // updateFilterParams(updatedFilterParams);
//         setFilterParams(updatedFilterParams);
//         props.fetchData(updatedFilterParams);
//       }
//       // else: do nothing (don't fire API)
//     }, 300);
//   };

//   const handleRowsPerPageChange = (newPerPage, page) => {
//     const updatedFilterParams = {
//       ...filterParams,
//       currentPage: page, // Reset to first page when changing rows per page
//       perPage: newPerPage,
//     };
//     // updateFilterParams(updatedFilterParams);
//   };

//   const handlePageChange = (page) => {
//     const updatedFilterParams = {
//       ...filterParams,
//       currentPage: page,
//     };
//     updateFilterParams(updatedFilterParams);
//   };

//   const exportToExcel = async () => {
//     let exportData;
//     // If rows are selected, export only the selected rows; otherwise, export all data
//     if (props.selectedRows && props.selectedRows.length > 0) {
//       exportData = props.selectedRows;
//     } else {
//       exportData = props.data;
//     }
//     try {
//       const ws = XLSX.utils.json_to_sheet(exportData);
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
//       XLSX.writeFile(wb, `${props.exportFileName || "data"}.xlsx`, {
//         bookType: "xlsx",
//         type: "buffer",
//         compression: true,
//       });
//     } catch (error) {
//       console.error("Error exporting to Excel:", error);
//     }
//   };

//   return (
//     <Row>
//       <Col lg={12}>
//         <Card style={{ marginTop: "15px", marginBottom: "60px" }}>
//           <CardBody>
//             <Row className="g-4">
//               <div className="col-sm">
//                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                   <div className="form-icon" style={{ flex: "1", maxWidth: "30%" }}>
//                     {props.searchEnable && (
//                       <div className="">
//                         <SearchField
//                           value={filterParams.search}
//                           onSearch={handleSearch}
//                           filterParams={filterParams}
//                           fetchData={props.fetchData}
//                         />
//                       </div>
//                     )}
//                   </div>
//                   <div>
                  
//                     {props.showAddButton && (
//                       <Button
//                         className="btn mb-3 btn-primary add-button-margin"
//                         color="primary"
//                         type="submit"
//                         onClick={props.addOnClickMethod}
//                       >
//                         <i className="ri-add-line"></i>
//                         {`${props.buttonName ? props.buttonName : "New"}`}
//                       </Button>
//                     )}
//                     {props.showOrderButton && (
//                       <Link
//                         to="/order/order-product"
//                         className="btn btn-primary add-button-margin"
//                       >
//                         Order Product
//                       </Link>
//                     )}
//                     {props.showExportButton && (
//                       <Button
//                         className="btn btn-primary add-button-margin"
//                         color="primary"
//                         type="submit"
//                         onClick={exportToExcel}
//                       >
//                         <i className="bx bxs-file-export"></i>Export
//                       </Button>
//                     )}
//                     {props.showBulkImportButton && (
//                       <Button
//                         className="btn btn-primary add-button-margin"
//                         color="primary"
//                         type="submit"
//                         onClick={props.bulkImport}
//                       >
//                         <i className="bx bxs-file-export"></i>BulkImport
//                       </Button>
//                     )}
//                     {props.selectedRows.length === 0 ? null : (
//                       <Button
//                         className="btn btn-danger "
//                         color="danger"
//                         disabled={props.selectedRows.length === 0}
//                         onClick={props.bulkDelete}
//                       >
//                         Delete Item
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </Row>
//             <div className="table-responsive table-card  mb-1 datatable" style={{ marginTop: "-5.8px" }}>
//               <DataTable
//                 theme={layoutModeType === "light" ? "" : "dark"}
//                 columns={props.columns}
//                 data={props.data}
//                 pagination
//                 highlightOnHover
//                 paginationServer
//                 selectableRows={props.checkboxEnabled ? props.checkboxEnabled : false}
//                 progressComponent={
//                   <div style={{ width: "100%" }}>
//                     <TableSkeleton rows={10} columns={props.columns.length} />
//                   </div>
//                 }
//                 progressPending={props.loading}
//                 onChangeRowsPerPage={handleRowsPerPageChange}
//                 sortServer
//                 persistTableHead
//                 paginationPerPage={filterParams.perPage}
//                 paginationTotalRows={props.totalRows}
//                 paginationDefaultPage={filterParams.currentPage}
//                 onSelectedRowsChange={({ selectedRows }) => {
//                   if (props.bulkSelected) {
//                     props.bulkSelected(selectedRows);
//                   }
//                 }}
//                 onChangePage={handlePageChange}
//                 // onSort={(sortingColumns, order) => {
//                 //   console.log("sortingColumns", order);
                
//                 //   let orderBy = sortingColumns.selector
//                 //     .toString()
//                 //     .replace("row => row.", "")
//                 //     .replace("(row) => row.", "")
//                 //     .replace("row%20=>%20row.", "");
//                 //   // Apply the toSnake transformation to orderBy (if needed)
//                 //   const transformedOrderBy = toSnake(orderBy);
//                 //   // Capitalize the order (e.g., 'asc' -> 'ASC')
//                 //   const transformedOrder = order.toUpperCase();
//                 //   // Create updated filter params
//                 //   const updatedFilterParams = {
//                 //     ...filterParams,
//                 //     order: transformedOrder,
//                 //     orderBy: transformedOrderBy,
//                 //   };
//                 //   // Update filter params and trigger the data fetch
//                 //   setFilterParams(updatedFilterParams);
//                 //   props.fetchData(updatedFilterParams);
//                 // }}


//                 onSort={(sortingColumns, order) => {
//                   // Extract the orderBy column name
//                   console.log(order);
//                   let orderBy = sortingColumns.selector
//                     .toString()
//                     .replace("row => row.", "")
//                     .replace("(row) => row.", "")
//                     .replace("row%20=>%20row.", "");
//                     console.log(orderBy);
                    
                                     
//                   const transformedOrderBy = toSnake(orderBy);
//                   console.log(transformedOrderBy);
//                   // Capitalize the order (e.g., 'asc' -> 'ASC')
//                   const transformedOrder = order.toUpperCase();
//                   // Create updated filter params
//                   const updatedFilterParams = {
//                     ...filterParams,
//                     order: transformedOrder,
//                     orderBy: transformedOrderBy,
//                   };
//                   // Update filter params and trigger the data fetch
//                   setFilterParams(updatedFilterParams);
//                   props.fetchData(updatedFilterParams);
//                 }}
//               />
//             </div>

//           </CardBody>
//         </Card>
//       </Col>
//     </Row>
//   );
// };

// export default CommonDataTable;








// /* eslint-disable no-const-assign */
// /* eslint-disable react/prop-types */
// import React, { useState } from "react";
// import SearchField from "./DataTableSearch";
// import DataTable, { createTheme } from "react-data-table-component";
// import { toSnake } from "./ReqResConvertCase";
// import { useSelector } from "react-redux";
// import * as XLSX from "xlsx";
// import { Button } from "reactstrap";
// import TableSkeleton from "./Skeleton";
// import { Link } from "react-router-dom";
// import { Card, CardBody, Col, Row } from "react-bootstrap";

// const CommonDataTable = (props) => {

//   const { layoutModeType } = useSelector((state) => ({
//     layoutModeType: state.Layout.layoutModeType,
//   }));

//   createTheme("dark", {
//     background: {
//       default: "transparent",
//     },
//   });

//   const [filterParams, setFilterParams] = useState(props.filterParams);

//   const updateFilterParams = async (newFilterParams) => {
//     setFilterParams(newFilterParams);
//     await props.fetchData(newFilterParams);
//   };

//   // const exportToExcel = async () => {
//   //   updateFilterParams({ ...filterParams, isDownload: true });
//   //   try {
//   //     await new Promise((resolve) => {
//   //       const interval = setInterval(() => {
//   //         if (filterParams.isDownload) {
//   //           clearInterval(interval);
//   //           resolve();
//   //         }
//   //       }, 100);
//   //     });

//   //     const ws = XLSX.utils.json_to_sheet(props.data);
//   //     const wb = XLSX.utils.book_new();
//   //     XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

//   //     XLSX.writeFile(wb, `${props.exportFileName || "data"}.xlsx`, {
//   //       bookType: "xlsx",
//   //       type: "buffer",
//   //       compression: true,
//   //     });
//   //     updateFilterParams({ ...filterParams, isDownload: false });
//   //   } catch (error) {
//   //     console.error("Error exporting to Excel:", error);
//   //     updateFilterParams({ ...filterParams, isDownload: false });
//   //   }
//   // };

//   // const exportToExcel = async () => {
//   //   let exportData;
//   //   // If rows are selected, export only the selected rows; otherwise, export all data
//   //   if (props.selectedRows && props.selectedRows.length > 0) {
//   //     exportData = props.selectedRows;
//   //   } else {
//   //     exportData = props.data;
//   //   }
//   //   try {
//   //     const ws = XLSX.utils.json_to_sheet(exportData);
//   //     const wb = XLSX.utils.book_new();
//   //     XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
//   //     XLSX.writeFile(wb, `${props.exportFileName || "data"}.xlsx`, {
//   //       bookType: "xlsx",
//   //       type: "buffer",
//   //       compression: true,
//   //     });
//   //   } catch (error) {
//   //     console.error("Error exporting to Excel:", error);
//   //   }
//   // };


//   const exportToExcel = async () => {
//     let exportData;
//     // If rows are selected, export only the selected rows; otherwise, export all data
//     if (props.selectedRows && props.selectedRows.length > 0) {
//       exportData = props.selectedRows;
//     } else {
//       exportData = props.data;
//     }
//     try {
//       const ws = XLSX.utils.json_to_sheet(exportData);
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
//       XLSX.writeFile(wb, `${props.exportFileName || "data"}.xlsx`, {
//         bookType: "xlsx",
//         type: "buffer",
//         compression: true,
//       });
//     } catch (error) {
//       console.error("Error exporting to Excel:", error);
//     }
//   };






//   const handleRowsPerPageChange = (newPerPage, page) => {
//     const updatedFilterParams = {
//       ...filterParams,
//       currentPage: page,
//       perPage: newPerPage,
//     };
//     setFilterParams(updatedFilterParams);
//     props.fetchData(updatedFilterParams);
//   };

//   return (
//     <Row>
//       <Col lg={12}>
//         <Card style={{ marginTop: "15px", marginBottom: "60px" }}>
//           <CardBody>
//             <Row className="g-4">
//               <div className="col-sm">
//                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                   <div className="form-icon" style={{ flex: "1", maxWidth: "30%" }}>
//                     {props.searchEnable && (
//                       <div className="">
//                         <SearchField
//                           filterParams={props.filterParams}
//                           fetchData={props.fetchData}
//                         />
//                       </div>
//                     )}
//                   </div>
//                   <div>
//                     {props.showAddButton && (
//                       <Button
//                         className="btn btn-primary add-button-margin"
//                         color="primary"
//                         type="submit"
//                         onClick={props.addOnClickMethod}
//                       >
//                         <i className="ri-add-line"></i>
//                         {`${props.buttonName ? props.buttonName : "New"}`}
//                       </Button>
//                     )}
//                     {props.showOrderButton && (
//                       <Link
//                         to="/order/order-product"
//                         className="btn btn-primary add-button-margin"
//                       >
//                         Order Product
//                       </Link>
//                     )}
//                     {props.showExportButton && (
//                       <Button
//                         className="btn btn-primary add-button-margin"
//                         color="primary"
//                         type="submit"
//                         onClick={exportToExcel}
//                       >
//                         <i className="bx bxs-file-export"></i>Export
//                       </Button>
//                     )}
//                     {props.showBulkImportButton && (
//                       <Button
//                         className="btn btn-primary add-button-margin"
//                         color="primary"
//                         type="submit"
//                         onClick={props.bulkImport}
//                       >
//                         <i className="bx bxs-file-export"></i>BulkImport
//                       </Button>
//                     )}
//                     {props.selectedRows.length === 0 ? null : (
//                       <Button
//                         className="btn btn-danger "
//                         color="danger"
//                         disabled={props.selectedRows.length === 0}
//                         onClick={props.bulkDelete}
//                       >
//                         Delete Item
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </Row>
//             <div className="table-responsive table-card  mb-1 datatable" style={{ marginTop: "-5.8px" }}>
//               <DataTable
//                 theme={layoutModeType === "light" ? "" : "dark"}
//                 columns={props.columns}
//                 data={props.data}
//                 pagination
//                 highlightOnHover
//                 paginationServer
//                 selectableRows={props.checkboxEnabled ? props.checkboxEnabled : false}
//                 progressComponent={
//                   <div style={{ width: "100%" }}>
//                     <TableSkeleton rows={10} columns={props.columns.length} />
//                   </div>
//                 }
//                 progressPending={props.loading}
//                 onChangeRowsPerPage={handleRowsPerPageChange}
//                 sortServer
//                 persistTableHead
//                 paginationPerPage={
//                   filterParams.perPage || process.env.REACT_APP_RECORDS_PER_PAGE
//                 }
//                 paginationTotalRows={props.totalRows}
//                 onSelectedRowsChange={({ selectedRows }) => {
//                   if (props.bulkSelected) {
//                     props.bulkSelected(selectedRows);
//                   }
//                 }}
//                 onSort={(sortingColumns, order) => {
//                   // Check if the selector is available
//                   let orderBy = "";

//                   if (sortingColumns && sortingColumns.selector) {
//                     // If selector is available, extract the function name and its path
//                     try {
//                       orderBy = sortingColumns.selector.toString();

//                       // Extract the property path from the function string, ignoring the row argument
//                       orderBy = orderBy.replace(/.*\.\.\.(row)\./, "").replace("row => row.", "").replace("row%20=>%20row.", "");

//                       // Ensure that orderBy becomes the actual field name (e.g., 'sku')
//                       orderBy = orderBy.split('.').pop();  // Just get the last part of the path (e.g., 'sku')
//                     } catch (error) {
//                       console.error("Error extracting field name from selector:", error);
//                       return;  // Exit early if there's an error in extracting the field name
//                     }
//                   } else {
//                     // If selector is not available, use a default extraction method
//                     orderBy = sortingColumns.selector
//                       .toString()
//                       .replace("row => row.", "")
//                       .replace("(row) => row.", "")
//                       .replace("row%20=>%20row.", "");
//                   }

//                   // Create the updated filter params object
//                   const updatedFilterParams = {
//                     ...filterParams,
//                     order,
//                     orderBy: toSnake(orderBy),  // Assuming you want to convert the field name to snake_case
//                   };

//                   // Set the updated filter params and fetch data
//                   setFilterParams(updatedFilterParams);
//                   props.fetchData(updatedFilterParams);
//                 }}

//                 onChangePage={(page) => {
//                   const updatedFilterParams = {
//                     ...filterParams,
//                     currentPage: page,
//                   };
//                   setFilterParams(updatedFilterParams);
//                   props.fetchData(updatedFilterParams);
//                 }}
//               />
//             </div>

//           </CardBody>
//         </Card>
//       </Col>
//     </Row>
//   );
// };

// export default CommonDataTable;








